import React from 'react';
import { ImageEditor } from './components/ImageEditor';

function App() {
  return <ImageEditor />;
}

export default App;